<div id="{{appName}}" class="header container-fluid" (window:resize)="onResize($event)">
    <header class="gray-header">

        <div *ngIf="isInternal" [hidden]="(envName === 'toyotaguide' || envName === 'lexusguide')" class="user-info">
            <!-- elastic search feature on hold for Aug-2021 production release -->
            <!--  <a href="#" class="search-wrapper" (click)="onSearch();" href="javascript:void(0);"> Search
                <span class="search-icon fa fa-search"></span>
            </a> -->
            <span class="user-name">Hello, {{this.authService.instance.getActiveAccount().username}}</span>
            <span class="logout" (click)="onLogout()">Sign Out</span>
        </div>
    </header>
    <header>
        <div class="logo">
            <span>
                <a class="" (click)="onLogoClick()" href="{{logoPath}}">
                    <img alt="Lexus" *ngIf="appName==='lexus' && isInternal" class="header-logo" border=0 [src]="commonService.commonFiles['internal-logo']">
                    <img alt="Lexus" *ngIf="appName==='lexusguide' && !isInternal" class="header-logocts" [src]="commonService.commonFiles['external-logo']"
                        border=0>
                    <img alt="Lexus" *ngIf="appName==='lexus' && !isInternal" class="header-logocts" [src]="commonService.commonFiles['external-logo']"
                        border=0>
                    <img alt="Toyota" *ngIf="appName==='toyota' && isInternal" class="header-logo" border=0 [src]="commonService.commonFiles['internal-logo']">
                    <img alt="Toyota" *ngIf="appName==='toyotaguide' && !isInternal" class="header-logocts" border=0 [src]="commonService.commonFiles['external-logo']">
                    <img alt="Toyota" *ngIf="appName==='toyota' && !isInternal" class="header-logocts" border=0 [src]="commonService.commonFiles['external-logo']">
                </a>
            </span>
        </div>
        <div class="clearfix"></div>
    </header>

</div>